/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import GeneralCard from '../general-card'
import { LinearProgress, Box, Typography, Avatar } from '@mui/material'
import {
  // AddPlaylistToLibraryButton,
  // RemoveFromLibraryButton,
  LikeButton
  // StartPlaylistButton,
  // ResumePlaylistButton
} from '../../action-buttons'
import clsx from 'clsx'
import { useStyles } from './style'
import { useFormFactor } from '../../../hooks'
import { getAuthor } from '../../../helpers/playlist'
import EmptyImgPlaylist from '../../icons/empty-img-playlist.svg'

const PlaylistCard = props => {
  const {
    content,
    progress,
    onSelect,
    onLike,
    loadingLike,
    className = ''
  } = props
  const { isDesktop } = useFormFactor()
  const classes = useStyles({ ...props, isDesktop })
  const cardContent = content && {
    ...content,
    primaryType: ['playlist'],
    subtitle: { html: content?.description }
  }
  const actions = {
    // leftActions: !progress ? (
    //   <>
    //     <StartPlaylistButton size='xs' />
    //     <AddPlaylistToLibraryButton size='xs' />
    //   </>
    // ) : (
    //   <>
    //     <ResumePlaylistButton size='xs' />
    //     <RemoveFromLibraryButton size='xs' />
    //   </>
    // ),
    rightActions: (
      <>
        <LikeButton
          likes={content?.likeCount ?? 0}
          hasLiked={content?.hasLiked}
          onClick={() => onLike(content.pk)}
          loading={loadingLike}
          size='xs'
        />
      </>
    )
  }

  const authorName = getAuthor(content)
  const isPlaylist = true

  return (
    <GeneralCard
      content={cardContent}
      actions={actions}
      onSelect={onSelect}
      stack={2}
      expand
      defaultImage={EmptyImgPlaylist}
      componentProps={{ title: 'h2' }}
      className={clsx(classes.root, className)}
      classes={{
        root: classes.root,
        card: classes.card,
        title: classes.title,
        image: classes.image,
        summary: classes.summary
      }}
      isPlaylist={isPlaylist}
    >
      {content?.author && (
        <Box display='flex' alignItems='center' mt={1}>
          <Box mr={0.5}>
            <Avatar alt={authorName} className={classes.avatar} />
          </Box>
          <Typography variant='body2' color='textSecondary'>
            by {authorName}
          </Typography>
        </Box>
      )}
      {progress ? (
        <Box display='flex' alignItems='center' mt={1} mb={-1}>
          <Box width='100%' mr={1}>
            <LinearProgress
              variant='determinate'
              value={Math.min(progress, 100)}
              aria-label={`playlist progress ${progress}%`}
              classes={{
                root: classes.progress,
                bar: classes.foreground,
                colorPrimary: classes.background
              }}
            />
          </Box>
          <Box minWidth={35}>
            <Typography variant='body2' color='textSecondary'>
              {`${Math.min(Math.round(progress), 100)}%`}
            </Typography>
          </Box>
        </Box>
      ) : null}
    </GeneralCard>
  )
}
PlaylistCard.propTypes = {
  /** Content to be displayed on card */
  content: PropTypes.object,
  /** The user's current progress through the playlist */
  progress: PropTypes.number,
  /** Callback function fired when the card is selected  */
  onSelect: PropTypes.func
}
PlaylistCard.defaultProps = {
  size: 'small',
  expand: false
}

export default PlaylistCard
